import { Link } from "qw-ui-lib-v2";

export function PageLogout() {
  return (
    <div className="page-error">
      <h1 className="page-error__title">You are logged out</h1>
      <p className="page-error__message">
        You have successfully logged out. Please log in again to continue.
      </p>
      <Link variant="primary" href={process.env.HOME_PAGE_URL}>
        Log in again
      </Link>
    </div>
  );
}
